import { h, Component } from 'preact';

import { formatCountdown } from '../../lib/conventionTvBoard';

// Bootstrap colour per countdown tone. The wording itself lives in
// lib/conventionTvBoard.js so this badge and the TV board cannot drift apart.
const TONE_CLASS = {
    soon: 'text-warning',
    future: 'text-info',
    past: 'text-body-tertiary',
};

// Live relative time to a stage's start — e.g. "om 2t 5min", "nå",
// "for 1t siden". Self-contained so it updates without re-rendering the parent.
// Pass `class` for layout (e.g. 'd-block') — the colour is set automatically.
class StageCountdown extends Component {
    constructor(props) {
        super(props);
        this.state = { now: Date.now() };
        this.timer = null;
    }

    componentDidMount() {
        this.timer = setInterval(() => this.setState({ now: Date.now() }), 30000);
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    render() {
        const { date } = this.props;
        const extraClass = this.props.class || '';
        const countdown = formatCountdown(date, this.state.now);
        if (!countdown) return null;
        return (
            <small class={`${TONE_CLASS[countdown.tone]} ${extraClass}`}>
                <i class='fa-regular fa-hourglass-half me-1' />
                {countdown.label}
            </small>
        );
    }
}

export default StageCountdown;
